import { DecimalPipe, CurrencyPipe, DatePipe } from "@angular/common";
import { ExportType } from "@fs/enums/common-enums";
import { EstimateGridModel } from "@fs/models/estimate/estimate-grid.model";
import { CommonMethods } from "@services/common.method";

export class MapExportData {

    static mapWorOrder(workOrder) {
        let excelRow: any = {};
        let hasPromisedDate = !(MapExportData.isNullOrUndefined(workOrder.PromisedDate));
        let totalAmount = workOrder.Total == null ? 0 : workOrder.Total;
        let hasCompletedDate = !(MapExportData.isNullOrUndefined(workOrder.CompletedDate));

        excelRow.PromisedDate = "";
        if (hasPromisedDate && workOrder.PromisedDate != "") {
            let promisedDate = new Date(workOrder.PromisedDate);
            excelRow.PromisedDate = (promisedDate.getMonth() + 1) + '/' + promisedDate.getDate() + '/' + promisedDate.getFullYear();
        }
        excelRow.PromisedTime = workOrder.PromisedTime;
        excelRow.WorkOrderNo = workOrder.WorkTicketNo;

        excelRow.PrimaryTechnician = workOrder.Technician;
        excelRow.StartTime = CommonMethods.Convert24HrsTo12Hrs(workOrder.StartTime, false);
        
        excelRow.CompletedDate = "";

        if (hasCompletedDate && workOrder.CompletedDate != "") {
            let completedDate = new Date(workOrder.CompletedDate);
            excelRow.CompletedDate = (completedDate.getMonth() + 1) + '/' + completedDate.getDate() + '/' + completedDate.getFullYear()
        }
        excelRow.DisplayName = "";
        excelRow.Address = "";
        if (workOrder.JobSite != null && workOrder.JobSite != undefined) {
            excelRow.DisplayName = workOrder.JobSite.DisplayName;
            excelRow.Address = this.GetInlineAddress(workOrder.JobSite.StreetNo, workOrder.JobSite.Unit,
                workOrder.JobSite.City, workOrder.JobSite.State) + ' ' + workOrder.JobSite.ZipCode;
        }
        excelRow.TotalAmount = this.ApplyCurrencyPipe(totalAmount)
        excelRow.DepartmentName = workOrder.Department;
        excelRow.Priority = workOrder.Priority;
        var Status = workOrder.Status.Name;
        var SubStatus = "";
        if (!CommonMethods.CheckNullOrUndefined(workOrder.Status.Code, false)) {
            (workOrder.Status.Code.toLowerCase() == "cancelled" || workOrder.Status.Code.toLowerCase() == "void") ? "" : workOrder.SubStatus.Name;
        }
        excelRow.SubStatus = (SubStatus != "") ? Status + '/ ' + SubStatus : Status;
        return excelRow;
    }

    static mapWorkOrderReview(workOrderReview) {
        let excelRow: any = {};
        let hasCompletedDate = !((MapExportData.isNullOrUndefined(workOrderReview.CompletedDate))
            || workOrderReview.CompletedDate == "");
        excelRow.CompletedDate = "";
        if (hasCompletedDate) {
            let completedDate = new Date(workOrderReview.CompletedDate);
            excelRow.CompletedDate = (completedDate.getMonth() + 1) + '/' + completedDate.getDate() + '/' + completedDate.getFullYear();
        }
        excelRow.WorkOrderNo = workOrderReview.WorkTicketNo;

        let hasInvoicedDate = !CommonMethods.CheckNullOrUndefined(workOrderReview.InvoiceDate, true);
        excelRow.InvoiceDate = "";
        if (hasInvoicedDate) {
            let invoicedDate = new Date(workOrderReview.InvoiceDate);
            excelRow.InvoiceDate = (invoicedDate.getMonth() + 1) + '/' + invoicedDate.getDate() + '/' + invoicedDate.getFullYear();
        }

        excelRow.PrimaryTechnician = workOrderReview.Technician;
        let totalAmount = workOrderReview.Total == null ? 0 : workOrderReview.Total;
        excelRow.TotalAmount = this.ApplyCurrencyPipe(totalAmount);
        let balanceDue = workOrderReview.BalanceDue == null ? 0 : workOrderReview.BalanceDue;
        excelRow.BalanceDue = this.ApplyCurrencyPipe(balanceDue)
        excelRow.DepartmentName = workOrderReview.Department;

        var Status = workOrderReview.Status.Name;
        var SubStatus = (workOrderReview.Status.Code.toLowerCase() == "cancelled"
            || workOrderReview.Status.Code.toLowerCase() == "void")
            ? "" : workOrderReview.SubStatus.Name;
        excelRow.SubStatus = Status + '/ ' + SubStatus;
        excelRow.DisplayName = "";
        excelRow.Address = "";
        if (workOrderReview.JobSite != undefined && workOrderReview.JobSite != null) {
            excelRow.DisplayName = workOrderReview.JobSite.DisplayName;
            excelRow.Address = this.GetInlineAddress(workOrderReview.JobSite.StreetNo, workOrderReview.JobSite.Unit,
                workOrderReview.JobSite.City, workOrderReview.JobSite.State) + ' ' +  workOrderReview.JobSite.ZipCode;
        }
        return excelRow;
    }

    static getPrimaryTech(workOrder) {
        if (workOrder.JobSite != undefined) {
            let primaryTechnician = workOrder.AssignedTechnicians.find(x => x.IsPrimary === true);

            if (primaryTechnician != undefined) {
                let user = primaryTechnician.User;
                let startTime = primaryTechnician.StartTime;
                if (user != undefined && startTime != undefined) {
                    let returnObject = {
                        TechnicianName: user.FirstName + " " + user.LastName,
                        StartTime: CommonMethods.Convert24HrsTo12Hrs(startTime, false)
                    };
                    return returnObject;
                }
                else
                    return null;
            }
        }
        else
            return null;
    }

    /**
    @remarks
    To map products
    @param fileType 1 : Excel, 2 : CSV, 3 : PDF
    */
    static mapProducts(product, fileType: ExportType) {
        let dataRow: any = {};
        dataRow.ItemNo = product.ItemNumber;
        dataRow.Description = product.Description;
        dataRow.Category = product.Category != undefined ? product.Category.Name : "";
        dataRow.FrequentlyUsed = product.IsFrequentlyUsed;
        dataRow.StandardPrice = (product.StandardPrice != null ? this.ApplyCurrencyPipe(product.StandardPrice) : '')
        dataRow.BaseUOM = product.BaseUOM;
        dataRow.PreferredSupplier = product.PreferredSupplier;
        dataRow.SupplierItem = product.SupplierItemNumber;
        dataRow.Type = product.Type;
        dataRow.ItemNote = product.Note;

        if (fileType != ExportType.PDF) {
            dataRow.IsPriceEditAllowed = product.IsPriceEditAllowed === true ? "Yes" : "No";
            dataRow.IsDescriptionEditAllowed = product.IsDescriptionEditAllowed === true ? "Yes" : "No";
            dataRow.IsDiscountExcluded = product.IsDiscountExcluded === true ? "Yes" : "No";
            dataRow.IsTaxable = product.IsTaxable === true ? "Yes" : "No";
            dataRow.BaseUOM = (product.BaseUOM != undefined && product.BaseUOM != null) ? product.BaseUOM : "";
            dataRow.AccountingCode = (product.AccountingCode != null && product.AccountingCode != undefined) ? product.AccountingCode.Name : "";
            dataRow.StandardCost = (product.Prices != undefined && product.Prices != null && product.Prices.length > 0) ? this.ApplyCurrencyPipe(product.Prices[0].Amount) : "";
        }
        return dataRow;
    }

    static mapDiscount(discount) {
        let dataRow: any = {};
        dataRow.Name = discount.Name;
        dataRow.DiscountType = discount.DiscountType.Name;
        dataRow.Amount = (discount.DiscountType.Code == "dollar") ? this.ApplyCurrencyPipe(discount.Amount) : this.ApplyDecimalPipe(discount.Amount);
        dataRow.MappingCode = discount.MappingCode;
        dataRow.IsAmountEditable = discount.IsAmountEditable;
        dataRow.IsNameEditable = discount.IsNameEditable;
        dataRow.IsActive = discount.IsActive === true ? "Active" : "Inactive";
        return dataRow;
    }
    static mapEquipment(equipment) {
        let dataRow: any = {};
        dataRow.Name = equipment.Name;
        dataRow.Description = equipment.Description;
        dataRow.DurationType = (CommonMethods.CheckNullOrUndefined(equipment.DurationType,false) || CommonMethods.CheckNullOrUndefined(equipment.DurationType.Name,false)) ? "" : equipment.DurationType.Name;
        dataRow.DurationValue = equipment.DurationValue;
        dataRow.IsActive = equipment.IsActive === true ? "Active" : "Inactive";
        return dataRow;
    }
    static mapProductCategory(categories) {
        let dataRow: any = {};
        dataRow.TradeName = categories["Trade"];
        dataRow.CategoryName = categories["Category"];
        dataRow.SubCategoryName = categories["SubCategory"];
        return dataRow;
    }

    static mapPaymentTerms(term) {
        let dataRow: any = {};
        dataRow.Name = term.Name;
        dataRow.Description = term.Description;
        dataRow.Days = term.TermDays;
        dataRow.MappingCode = term.MappingCode;
        dataRow.IsActive = term.IsActive === true ? "Active" : "Inactive";
        return dataRow;
    }

    static mapTaxMaintenance(data) {
        let dataRow: any = {};
        dataRow.Name = data["Name"];
        dataRow.Description = data["Description"];
        dataRow.AccountingTaxCode = data["MappingCode"];
        dataRow.IsActive = data["IsActive"];
        dataRow.TaxCodes = data["TaxCodes"];
        return dataRow;
    }

    static mapTaxMaintenanceForExcel(taxGroups: any[]) {
        let printarray = [];
        taxGroups.forEach(x => {
            printarray.push({
                Name: x.Name, Description: x.Description, AccountingTaxCode: x.AccountingTaxCode, Status: x.IsActive ? "Active" : "Inactive",
                TaxRateName: "", TaxRate: ""
            });
            if (x.TaxCodes != null && x.TaxCodes != undefined && x.TaxCodes.length > 0) {
                x.TaxCodes.forEach(y => {
                    printarray.push({
                        Name: x.Name, Description: x.Description, AccountingTaxCode: x.AccountingTaxCode, Status: x.IsActive ? "Active" : "Inactive",
                        TaxRateName: y.Name, TaxRate: new DecimalPipe('en-US').transform(y.Rate, '1.3-3')
                    });
                });
            }
        })
        return printarray;
    }

    static mapPromisedTime(pTime) {
        let dataRow: any = {};
        dataRow.Name = pTime.Name;
        dataRow.Description = pTime.Description;
        dataRow.BeginTime = this.timeFormat(pTime.BeginTime)
        dataRow.BeginAMPM = this.getAmPm(pTime.BeginTime)
        dataRow.EndTime = this.timeFormat(pTime.EndTime)
        dataRow.EndAMPM = this.getAmPm(pTime.EndTime)

        dataRow.IsActive = pTime.IsActive === true ? "Active" : "Inactive";
        return dataRow;
    }

    static mapCompanyCodes(companyCode) {
        let dataRow: any = {};
        dataRow.Name = companyCode.Name;
        dataRow.Description = companyCode.Description;
        dataRow.IsActive = companyCode.IsActive === true ? "Active" : "Inactive";
        return dataRow;
    }

    static mapAccountingCodes(companyCode) {
        let dataRow: any = {};
        dataRow.Name = companyCode.Name;
        dataRow.Description = companyCode.Description;
        dataRow.MappingCode = companyCode.MappingCode;
        dataRow.IsActive = companyCode.IsActive === true ? "Active" : "Inactive";
        return dataRow;
    }
    static mapAllCustomerdata(dataArray) {
        let count = dataArray.length;
        let dataItems = [];
        for (let i = 0; i <= count; i++) {
            let dataItem = MapExportData.mapCustomerData(dataArray[i]);
            dataItems.push(dataItem);
        };
        return dataItems;
    }
    static mapCustomerData(data) {
        let dataRow: any = {};
        if (data != null && data != null) {
            dataRow.JobSiteDisplayName = data.DisplayName;
            dataRow.JobSiteAddress = this.GetInlineAddress(data.StreetNo, data.Unit, data.City, data.State) + ' ' +  data.ZipCode;
            dataRow.JobSiteType = data.Type.Name;
            dataRow.JobSiteStatus = data.IsActive ? "Active" : "Inactive";
            dataRow.NextScheduledWorkOrder = (CommonMethods.CheckNullOrUndefined(data.NextWorkTicketNo) ? "" : (new DatePipe('en-US').transform(data.NextWorkTicketDate, 'MM/dd/yyyy') + " " + data.NextWorkTicketNo));

            dataRow.ContactPhone = data.Phone;
            dataRow.JobSiteEmail = data.Email;
            dataRow.JobSiteContact = data.ContactName;
            dataRow.JobSiteName = data.Type.Name == 'Individual' ? data.FirstName + ' ' + data.LastName : data.CompanyName;
            dataRow.TotalJobSiteCount = data.JobSiteCount;
            dataRow.JobSiteSince = new DatePipe('en-US').transform(data.JobsiteSince, 'MM/dd/yyyy');
            dataRow.TaxCode = data.TaxGroup;
            dataRow.JobSiteAccountingIntegration = (data.IntegrationStatus != null) ? data.IntegrationStatus.Name : "";
            dataRow.JobSiteComment = data.Comment;

            if (data.Customer != null) {
                dataRow.CustomerDisplayName = data.Customer.DisplayName;
                dataRow.CustomerAddress = this.GetInlineAddress(data.Customer.StreetNo, data.Customer.Unit, data.Customer.City, data.Customer.State) + ' ' +  data.Customer.ZipCode;
                if (data.Customer.Type.Name != null) {
                    dataRow.CustomerType = data.Customer.Type.Name;
                    dataRow.CustomerName = data.Customer.Type.Name == 'Individual' ? data.Customer.FirstName + ' ' + data.Customer.LastName : data.Customer.CompanyName;
                }
                dataRow.CustomerStatus = data.Customer.IsActive ? "Active" : "Inactive";

                dataRow.CustomerEmail = data.Customer.Email;
                dataRow.CustomerPhoneNumber = data.Customer.Phone;
                dataRow.CustomerContact = data.Customer.ContactName;
                dataRow.PaymentTerms = data.Customer.PaymentTerm
                dataRow.CustomerAccountingIntegration = (data.Customer.IntegrationStatus != null) ? data.Customer.IntegrationStatus.Name : "";
                dataRow.CustomerComment = data.Customer.Comment;
                dataRow.CustomerSince = new DatePipe('en-US').transform(data.Customer.CustomerSince, 'MM/dd/yyyy');
            }
        }
        return dataRow;
    }
    static mapServiceAgreement(serviceagreement) {
        let excelRow: any = {};
        let hasEffectiveDate = !(MapExportData.isNullOrUndefined(serviceagreement.EffectiveDate));
   
        excelRow.AgreementNo = serviceagreement.ServiceAgreementNumber;
        excelRow.AgreementName = serviceagreement.ItemNumber;
        excelRow.EffectiveDate = new DatePipe('en-US').transform(serviceagreement.EffectiveDate, 'MM/dd/yyyy');
        excelRow.ExpirationDate = new DatePipe('en-US').transform(serviceagreement.ExpirationDate, 'MM/dd/yyyy');
        excelRow.Length = serviceagreement.Length;
        excelRow.Interval = serviceagreement.Interval;
        excelRow.JobSiteDisplayName = serviceagreement.JobSite.DisplayName;
        excelRow.Status = serviceagreement.Status;
        return excelRow;
    }
    static mapVisit(data) {
        let excelRow: any = {};
   
        excelRow.AgreementNo = data.AgreementNumber;
        excelRow.JobSiteDisplayName = data.JobSite.DisplayName;
        excelRow.JobSiteAddress = this.GetInlineAddress(data.JobSite.StreetNo, data.JobSite.Unit, data.JobSite.City, data.JobSite.State) + ' ' +  data.JobSite.ZipCode;
        excelRow.FollowupDate = new DatePipe('en-US').transform(data.FollowupDate, 'MM/dd/yyyy');
        excelRow.ProposedDate = new DatePipe('en-US').transform(data.ProposedDate, 'MM/dd/yyyy');
        excelRow.Status = data.Status;
        excelRow.AttemptCount = data.AttemptCount;
        excelRow.ContactNumber = data.ContactPhone?data.ContactPhone.PhoneNumber: "";
        return excelRow;
    }
    static mapEstimate(data: EstimateGridModel) {
        let excelRow: any = {};
   
        excelRow.EstimateNo = data.EstimateNo;
        excelRow.Description = data.Description;
        excelRow.JobSiteDisplayName = data.JobSite.DisplayName;
        excelRow.JobSiteAddress = this.GetInlineAddress(data.JobSite.StreetNo, data.JobSite.Unit, data.JobSite.City, data.JobSite.State) + ' ' +  data.JobSite.ZipCode;
        excelRow.CreateDate = new DatePipe('en-US').transform(data.CreateDate, 'MM/dd/yyyy');
        excelRow.ExpirationDate = new DatePipe('en-US').transform(data.ExpirationDate, 'MM/dd/yyyy');
        excelRow.Total = data.Total;
        excelRow.Status = data.Status? data.Status.Name : "";
        excelRow.Technician = data.Technician;
        excelRow.Date = new DatePipe('en-US').transform(data.PromisedDate, 'MM/dd/yyyy');
        excelRow.Time = data.StartTime;
        excelRow.AppointmentStatus = (data.AppointmentStatus)? data.AppointmentStatus.Name : "";
        return excelRow;
    }
    static getAmPm(Time) {
        let hours = parseInt(Time.toString().split(":")[0]);
        if (hours >= 12) {
            return "PM"
        }
        else if (hours < 12) {
            return "AM"
        }
    }
    static timeFormat(time) {
        if (time == "" || time == null)
            return "";
        let hours = parseInt(time.split(":")[0]) > 12 ? parseInt(time.split(":")[0]) - 12 : (parseInt(time.split(":")[0]) == 0 ? 12 : parseInt(time.split(":")[0]));
        return ((hours <= 9) ? ("0" + hours) : hours) + ":" + time.split(":")[1];
    }

    static isNullOrUndefined(val: any) {
        return (val == undefined || val == null) ? true : false;
    }
    static ApplyDecimalPipe(value: any): any {
        if (value == undefined || value == null) {
            return "";
        }
        var val = value.toString().replace(/,/g, '');
        if (parseFloat(val) != NaN) {
            return new DecimalPipe('en-US').transform(val, '1.2-2');
        }
        else {
            return value;
        }
    }
    static ApplyCurrencyPipe(value: any): any {
        if (value == undefined || value == null) {
            return "";
        }
        var val = value.toString().replace(/,/g, '');
        if (parseFloat(val) != NaN) {
            return new CurrencyPipe('en-US').transform(val, 'USD');
        }
        else {
            return value;
        }
    }
    static GetInlineAddress(street, unit, city, state): string {
        return (street +  ', ' +  ((unit)?  unit +  ', ':'') + city +  ', ' + state );
    }
    static GetPrimaryContact(contacts) {
        return contacts.filter(x => x.Contact.IsPrimary);
    }
}